// frontend/modules/service-metrics/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import ServiceMetricsDashboardView from './views/ServiceMetricsDashboardView';
import CircuitBreakerView from './views/CircuitBreakerView';

export const serviceMetricsRoutes: RouteObject[] = [
    {
        path: '/admin/service-metrics',
        element: <ServiceMetricsDashboardView />,
        errorElement: <ErrorBoundary />,
    },
    {
        path: '/admin/circuit-breaker',
        element: <CircuitBreakerView />,
        errorElement: <ErrorBoundary />,
    },
];
